import { render, staticRenderFns } from "./ExternalLinkButton.vue?vue&type=template&id=561d169c&scoped=true&"
import script from "./ExternalLinkButton.vue?vue&type=script&lang=js&"
export * from "./ExternalLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./ExternalLinkButton.vue?vue&type=style&index=0&id=561d169c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d169c",
  null
  
)

export default component.exports